// Short producer names keep strain titles within Google's ~60-char limit.
const SHORT_PRODUCERS = {
  "Aurora Deutschland GmbH": "Aurora",
  "Canopy Growth (Spectrum Therapeutics)": "Canopy",
  "Four 20 Pharma (Curaleaf)": "Four 20",
  "Medalchemy (Curaleaf)": "Medalchemy",
  "Suprobion (S-Lab)": "Suprobion",
  "Synoptis Pharma": "Synoptis",
  "Bliss Pharma": "Bliss",
  "PhytoPūr Bio": "PhytoPūr",
};

export const shortProducer = (p) => SHORT_PRODUCERS[p] || p;